import React, { useState } from "react";

import Dialog from "@mui/material/Dialog";
import Divider from "@mui/material/Divider";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuListItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { globalStyles } from "@client/shared/constants";
import { Box } from "@mui/material";
import aboutStyles from "./styles";

const AboutModal = ({ classes: passedClasses = {}, version = {} }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <MenuListItem onClick={() => setIsOpen(true)}>
        <ListItemText primary="About" />
        <ListItemIcon sx={aboutStyles.icon}>
          <InfoOutlinedIcon fontSize="small" />
        </ListItemIcon>
      </MenuListItem>

      {/* <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
        <DialogTitle hasClose sx={aboutStyles.aboutHeading}>
          <Box sx={{ display: "flex" }}>
            <img src={`/assets/logo.png`} alt="" width={28} height={28} />
            <Typography variant="h6" sx={{ ml: 2, color: "secondary.dark" }}>
              Notifications Plus
            </Typography>
          </Box>
          <IconButton aria-label="close" onClick={() => setIsOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={aboutStyles.dialogContent}>
          <Box>
            <Divider />
            <Box sx={aboutStyles.group}>
              <Typography variant="subtitle2">Version:</Typography>
              <Typography variant="subtitle2" sx={aboutStyles.values}>
                {version.release || "1.0"}
              </Typography>
            </Box>
            <Divider />
            <Box sx={aboutStyles.group}>
              <Typography variant="subtitle2">Date:</Typography>
              <Typography variant="subtitle2" sx={aboutStyles.values}>
                {version.date || "22-12-2022"}
              </Typography>
            </Box>
            <Divider />
          </Box>
        </DialogContent>
      </Dialog> */}

      <Dialog
        classes={{
          paper: aboutStyles.dialog,
        }}
        open={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <IconButton sx={{ ml: 100, mr: 1, width: 30 }}>
          <CloseIcon
            sx={{ color: "grey.600" }}
            fontSize="small"
            onClick={() => setIsOpen(false)}
          />
        </IconButton>
        <DialogContent>
          <Box
            sx={{
              color: "grey",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2,
            }}
          >
            <img
              style={{
                marginBottom: 6,
                marginLeft: 6,
              }}
              src="/assets/brand-logo.svg"
              height={60}
            />
            <Typography sx={{ mb: 4 }} variant="subtitle2">
              Release {version.release}, Build {version.build}
            </Typography>
            <img
              style={{
                marginBottom: 3,
              }}
              src="/assets/ringcentral-logo.svg"
            />
            <Typography sx={{ mb: 4 }} variant="body2">
              &copy; 2020 RingCentral Professional Services
            </Typography>
            <Typography sx={{ mb: 4 }} variant="button">
              ACKNOWLEDGEMENTS
            </Typography>
            <Typography sx={{ fontWeight: "bold" }} variant="subtitle2">
              Created By:
            </Typography>
            <Typography variant="subtitle2">John Celoria</Typography>
            <Typography sx={{ mt: 3, fontWeight: "bold" }} variant="subtitle2">
              Design:
            </Typography>
            <Typography variant="subtitle2">Andrew Miller</Typography>
            <Typography sx={{ mt: 3, fontWeight: "bold" }} variant="subtitle2">
              Development:
            </Typography>
            <Typography variant="subtitle2">Thinksys Inc.</Typography>
            <Typography sx={{ mt: 3, fontWeight: "bold" }} variant="subtitle2">
              Special Thanks:
            </Typography>
            <Typography variant="subtitle2">
              Thomas Cain, Kyle Cleveland, Erica Kirshner,
            </Typography>
            <Typography variant="subtitle2">Raffi Makhoulian</Typography>
          </Box>
        </DialogContent>
        <DialogActions />
      </Dialog>
    </>
  );
};

export default AboutModal;
